module.exports = __webpack_public_path__ + "img/3-3.7943da51.png";